module.exports = __webpack_public_path__ + "static/media/admin.fdbb347e.pdf";